import { Button } from 'antd'
import { FC } from 'react'
import { RowNode } from '@/presentation/common/components/dataGrid/lib/api.types.ts'
import { useCrud } from '@/presentation/common/hooks/crud/useCrud.ts'
import { useMaintainerStore } from '@/presentation/common/store/zustand/maintainer.ts'
import { DeleteInventoriesFormProps } from '@/presentation/inventories/forms/types.ts'
import { useDeleteInventories } from '@/presentation/inventories/hooks/useDeleteInventories.ts'
import { QueryInventoriesForTableResult } from '@/presentation/inventories/hooks/useQueryInventoriesForTable.ts'

export const DeleteInventoriesForm: FC<DeleteInventoriesFormProps> = ({ onCancel, onFinish }) => {
  const messageApiKey = 'DeleteInventoriesForm-alert'
  const { submit, isSuccess, isLoading, isError, message } = useDeleteInventories()
  useCrud({ messageApiKey, message, isSuccess, isLoading, isError })

  const selectionNodes = useMaintainerStore((state) => state.selectionV2)
  const ids = Object.values(selectionNodes).map((node: RowNode<QueryInventoriesForTableResult['items'][0]>) => node.data?.id)

  const onConfirmDelete = async () => {
    if (isLoading) {
      return
    }

    await submit({ ids })
    onFinish?.()
  }

  return (
    <>
      <p className="text-center mb-6">
                Está apunto de eliminar los espacios seleccionados ({ids.length}).<br/>
                ¿Desea continuar con esta operación?
      </p>
      <div className="flex justify-center gap-2.5 pb-2">
        <Button size="small" type="primary" onClick={onCancel}>Cancelar</Button>
        <Button size="small" type="primary" danger onClick={onConfirmDelete}
          disabled={isLoading}>Eliminar</Button>
      </div>
    </>
  )
}
